import { Injectable } from '@angular/core';
import { SocratesImage, } from '@socrates/common';
import { IImagesRepo } from '../repository/interfaces/iimages.repo';

@Injectable()
export class ImageGrabService {

	constructor(
		private imagesRepo: IImagesRepo,
	) {
	}

	grabImage(path: string): Promise<SocratesImage> {
		return this.imagesRepo.tunnelImage(path);
	}
}
